import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import Form from 'src/components/controls/forms/Form';
import Textbox from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';
import PerformanceComment from 'src/models/PerformanceComment';
import UserDetails from 'src/models/UserDetails';
import PropertyUtil from 'src/util/PropertyUtil';

interface IEditCommentDialogProps {
    user: UserDetails;
    updatePerformanceComment: (comment: PerformanceComment) => void;
    selectedComment: PerformanceComment;
}

class EditCommentDialog extends React.Component<IEditCommentDialogProps> {
    handleEditCommentSubmit = (values: { comment: string }) => {
        let comment = new PerformanceComment();

        comment = this.props.selectedComment;
        comment.commentText = values.comment;
        comment.isEdited = true;
        comment.editAuthorId = parseInt(this.props.user.userId + '', 10);
        comment.editCommentDate = new Date();

        this.props.updatePerformanceComment(comment);
    };

    public render() {
        return (
            <Dialog dialogName={DialogList.EDIT_COMMENT} title="Edit Comment">
                <Form
                    onSubmit={this.handleEditCommentSubmit}
                    initialValues={{ comment: PropertyUtil.SafeGet(() => this.props.selectedComment.commentText) }}
                >
                    <Textbox name="comment" label="Comment" />
                    <Button type="submit" text="Save" />
                </Form>
            </Dialog>
        );
    }
}

export default EditCommentDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/EditCommentDialog.tsx